<template>
    <b-modal
        ref="modalDeletePayment"
        title-tag="h2"
        @show="onShow"
        :title="title"
        lazy
        footer-class="d-flex justify-content-between"
    >
        <div v-if="warningMessagePayment">
            <div class="alert-wrapper">
                <div class="alert alert-warning alert-dismissible" role="alert">
                    {{ warningMessagePayment }}
                </div>
            </div>
        </div>
        {{ message }}
        <form>
            <b-form-group
                v-if="isShowTerminal"
                :label-for="`terminal`"
                label-cols="4"
                label="Terminal:"
            >
                <b-form-select
                    id="terminal"
                    v-model="payment.terminal"
                    v-validate="'excluded:0'"
                    :class="{ 'border-danger': errors.has('terminal') }"
                    :disabled="isNoTerminal"
                    name="terminal"
                >
                    <option
                        v-for="(value, key) in payment.terminals"
                        :key="key"
                        :value="key"
                        >{{ value }}</option
                    >
                </b-form-select>
            </b-form-group>
        </form>

        <div slot="modal-footer" class="w-100">
            <b-button
                v-if="!isLoading"
                @click="close"
                class="float-left"
                variant="secondary"
                >Cancel</b-button
            >
            <div v-if="isLoading">
                <b-btn
                    v-if="isReadyToCancel"
                    class="float-left"
                    variant="secondary"
                    @click="resetStripeTerminal"
                    >Cancel
                </b-btn>
            </div>
            <div class="float-right" style="margin-top: 0.5rem;">
                <span v-if="cancelling">Cancelling</span>
                <span
                    ><img
                        v-if="isLoading"
                        class="float-right"
                        src="assets/ajax-loader.gif"
                /></span>
            </div>
            <div class="float-right">
                <b-button
                    v-if="!isLoading"
                    @click="proceedDelete"
                    :disabled="isHasUsersChooseInvoice"
                    class="float-left"
                    variant="primary"
                    >{{ button }}</b-button
                >
            </div>
        </div>
    </b-modal>
</template>
<script type="text/javascript">
import BillingPayment from "@/services/billing/billing-payments";
import PaymentDialogHelper from "@/module/payment/helper.js";

export default {
    mixins: [PaymentDialogHelper],
    props: {
        payment: {
            type: Object,
            default() {
                return {};
            }
        },
        invoiceId: {
            type: String,
            default: null
        }
    },
    computed: {
        isNoTerminal() {
            return (
                this.payment.terminals &&
                this.payment.terminals[0] == "No Terminal"
            );
        },
        isHasUsersChooseInvoice() {
            return this.warningMessagePayment !== "";
        },
        warningMessagePayment() {
            return this.invoiceId
                ? this.$store.getters["billing/warningMessagePayment"](
                      this.invoiceId
                  )
                : "";
        }
    },
    data() {
        return {
            title: "Delete Payment",
            message:
                "Deleting this payment will delete all credits and refunds related with this payment. Do you want to delete this payment?",
            button: "Delete",
            isDelete: true,
            isLoading: false,
            isShowTerminal: false,
            isStripeInterac: false,
            cancelling: false,
            isReadyToCancel: null
        };
    },
    created() {
        this.$root.$on("stripe-reset-terminal", this.cancelStripeCollection);
    },
    methods: {
        async open() {
            this.$nextTick(() => {
                this.title = `Delete Payment #${this.payment.index}`;
                if (this.payment.transaction_id) {
                    this.title = `Refund to Card (Payment #${this.payment.index})`;
                    this.message =
                        "This payment will be refunded to the card that it was charged to, and the invoice that it was associated with will be reopened. Any credits associated with this payment will also be deleted. Do you want to refund this payment?";
                    this.button = "Refund";
                    this.isDelete = false;
                }
            });

            if (
                this.payment.trans_type &&
                this.payment.trans_type == "interac_present"
            ) {
                await this._getTerminals(this.payment);
                this.isShowTerminal = true;
                this.isStripeInterac = true;
            }

            this.$refs.modalDeletePayment.show();
        },
        async proceedDelete() {
            let self = this;
            let valid = true;

            self.isLoading = true;

            if (self.payment && self.isStripeInterac && self.payment.terminal) {
                valid = false;
                let data = {
                    business_id: self.payment.business_id,
                    amount: self.payment.amount,
                    reader_id: self.payment.terminal,
                    transaction_id: self.payment.charge.payment_intent
                };
                // process stripe refund first
                await this._proceedStripeInteracRefund(data).then(response => {
                    console.log("proceedStripeInteracRefund", response);
                    if (response.state == 0) {
                        valid = true;
                        self.payment["refund_object"] = response.refund;
                    } else {
                        self._message(response.message);
                        self.isLoading = false;
                    }
                });
            }

            if (valid) {
                BillingPayment.removePayment(self.payment)
                    .then(response => {
                        if (response.code == 200) {
                            this._message(response.message);
                            this.$emit("reload");
                        } else if (response.code == 400) {
                            this._message(response.message, "danger");
                        } else {
                            throw "ERROR";
                        }

                        this.close();
                    })
                    .catch(error => {
                        if (this.isDelete) {
                            this._message(
                                "Error : Unable to delete payment",
                                "danger"
                            );
                        } else {
                            this._message(
                                "Error : Unable to refund payment",
                                "danger"
                            );
                        }

                        this.close();
                        console.error(error);
                    });
            }
        },
        close() {
            this.isLoading = false;
            this.$refs.modalDeletePayment.hide();
        },
        onShow() {
            this.$emit("loaded");
        },
        resetStripeTerminal() {
            this.cancelling = true;
            this._cancelStripeTerminal(this.isReadyToCancel);
        },
        cancelStripeCollection(stripeTerminal) {
            this.isReadyToCancel = stripeTerminal;
        }
    }
};
</script>
